import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 班次添加 修改
import { shiftAdd, shiftEdit, addShiftInfo } from 'api/frequency';
import { checkSupervisor } from 'api/Attendance';
import framework from '_c/framework';
var form = function form() {
  return {
    is_rest: false,
    name: '',
    // 名称
    start: '09:00',
    // 开始时间
    end: '18:00',
    // 结束时间
    rest_start: '12:00',
    // 结束时间
    rest_end: '13:00',
    // 结束时间
    on_min_ago: undefined,
    // 上班前多久打卡（分钟）
    off_min_later: undefined,
    // 下班前多久打卡
    user_friendly: 0,
    // 人性化考勤设置 0 无 1 豁免时间 2 弹性考勤
    exempt_start: 15,
    // 上班豁免时间（分钟）
    exempt_end: 15,
    // 下班豁免时间（分钟）
    flexible_start_later: 30,
    // 弹性考勤上班晚到时间（分钟）
    flexible_start_ago: 30,
    // 弹性考勤上班早到时间（分钟）
    is_default: false,
    supervisor_staff_list: [],
    supervisor_staff_ids: []
  };
};
export default {
  props: {},
  components: {
    framework: framework
  },
  data: function data() {
    var self = this;
    return {
      visible: false,
      type: false,
      // 1 新建 2 编辑
      disabled: false,
      // save button disabled
      orgVisibleLead: false,
      // 选择班次负责人
      default_supervisor: {},
      form: form(),
      isTip: false,
      title: '',
      // 标题
      rules: {
        name: [{
          required: true,
          message: this.$t('1365'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('772'),
          trigger: 'blur'
        }],
        supervisor_staff_ids: [{
          validator: function validator(rule, value, callback) {
            if (value && !value.length && !!self.type) {
              return callback(new Error(rule.message));
            } else {
              callback();
            }
          },
          required: true,
          message: this.$t('221'),
          trigger: ['blur', 'change']
        }],
        time: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var _self$form = self.form,
              start = _self$form.start,
              end = _self$form.end;
            if (start && end) return callback();
            // 请选择班次时间
            return callback(new Error(self.$t('1366')));
          }
        }],
        rest: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!self.form.is_rest) return callback();
            if (self.form.rest_start && self.form.rest_end) return callback();
            // 休息时间应在上下班时间内
            return callback(new Error(self.$t('1716')));
          }
        }]
      }
    };
  },
  computed: {
    showNext: function showNext() {
      var _this$form = this.form,
        start = _this$form.start,
        end = _this$form.end;
      if (!start || !end) return false;
      if (Number(start.replace(':', '') > Number(end.replace(':', '')))) return true;
      return false;
    },
    showNext1: function showNext1() {
      var _this$form2 = this.form,
        rest_start = _this$form2.rest_start,
        rest_end = _this$form2.rest_end;
      if (!rest_start || !rest_end) return false;
      if (Number(rest_start.replace(':', '') > Number(rest_end.replace(':', '')))) return true;
      return false;
    }
  },
  methods: {
    init: function init(msg, is_default) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$addShiftInfo, data, supervisor_staff_list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.is_default = !!is_default;
              _this.title = msg.title;
              _this.type = msg.type;
              _this.visible = true;
              _context.next = 6;
              return addShiftInfo();
            case 6:
              _yield$addShiftInfo = _context.sent;
              data = _yield$addShiftInfo.data;
              _this.default_supervisor = data.default_supervisor || {};
              // 新建字段清空
              if (msg.type === 1) {
                _this.form = form();
                _this.form.supervisor_staff_list = _this.default_supervisor ? [_this.default_supervisor] : [];
                _this.form.supervisor_staff_ids = _this.default_supervisor ? [_this.default_supervisor.staff_id] : [];
              } else {
                msg.info.supervisor_staff_ids = [];
                _this.form = JSON.parse(JSON.stringify(msg.info));
                _this.form.end = _this.form.end.replace(/[\u4e00-\u9fa5]+/g, '');
                supervisor_staff_list = _this.form.supervisor_staff_list;
                _this.handleStaffList(supervisor_staff_list, 'supervisor_staff_ids', 'supervisor_staff_list');
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleStaffList: function handleStaffList(data, ids, list) {
      var _this2 = this;
      var staffs = [];
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this2.form[ids].push(item.id || item.staff_id);
          staffs.push({
            staff_id: item.staff_id || item.id,
            staff_name: item.staff_name || item.name,
            staff_name_en: item.staff_name_en,
            staff_name_secondary: item.staff_name_secondary,
            staff_name_th: item.staff_name_th || item.name,
            avatar_url: item.avatar_url,
            id: item.id,
            name: item.name
          });
        });
      }
      this.form[list] = staffs;
    },
    leadStaffList: function leadStaffList() {
      var staffName = '';
      var list = this.form.supervisor_staff_list || [];
      if (list.length) {
        list.forEach(function (item, index) {
          if (list.length - 1 === index) {
            staffName += item.staff_name;
          } else {
            staffName += item.staff_name + ', ';
          }
        });
      }
      return staffName;
    },
    handleLeadDepart: function handleLeadDepart(params) {
      var _this3 = this;
      var ids = this.form.supervisor_staff_ids;
      var list = this.form.supervisor_staff_list;
      // 校验已选成员是否包含当前登录账号人员（当前登录账号为主管理员无须校验）
      checkSupervisor({
        supervisor_staff_ids: params.staffIds
      }).then(function (_ref) {
        var data = _ref.data;
        if (data && !data.check_result) {
          if (!params.staffIds.includes(_this3.default_supervisor.staff_id)) {
            _this3.$confirm(_this3.$t('6c0495da'), _this3.$t('229'), {
              confirmButtonText: _this3.$t('131'),
              cancelButtonText: _this3.$t('66'),
              type: 'warning'
            }).then(function () {
              _this3.orgVisibleLead = false;
              _this3.form.supervisor_staff_ids = params.staffIds;
              _this3.form.supervisor_staff_list = params.staff_list;
            }).catch(function () {
              _this3.form.supervisor_staff_ids = ids;
              _this3.form.supervisor_staff_list = list;
            });
          }
        } else {
          _this3.form.supervisor_staff_ids = params.staffIds;
          _this3.form.supervisor_staff_list = params.staff_list;
          _this3.orgVisibleLead = false;
        }
      });
    },
    // 提交
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;
      if (!this.type) {
        this.disabled = false;
        this.visible = false;
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.disabled = true;
          // 根据type来判断新建或者编辑
          var requestMethods = _this4.type && _this4.type === 1 ? shiftAdd : shiftEdit;
          if (!_this4.form.is_rest) {
            _this4.form.rest_start = '12:00';
            _this4.form.rest_end = '13:00';
          }
          requestMethods(_this4.form).then(function () {
            _this4.visible = false;
            _this4.$emit('updateList');
          }).finally(function () {
            return _this4.disabled = false;
          });
        }
      });
    },
    handleClosed: function handleClosed() {
      this.$refs.form.resetFields();
    },
    handleSelectChange: function handleSelectChange(v) {}
  }
};